import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './restaurantPublishedLegalDocumentsQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type RestaurantPublishedLegalDocumentsQuery_restaurant_Restaurant_publishedLegalDocuments_RestaurantPublishedLegalDocument = {
  __typename: 'RestaurantPublishedLegalDocument',
  id: string,
  content: string,
  documentType: string
};

export type RestaurantPublishedLegalDocumentsQuery_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number,
  publishedLegalDocuments: Array<RestaurantPublishedLegalDocumentsQuery_restaurant_Restaurant_publishedLegalDocuments_RestaurantPublishedLegalDocument>
};

export type RestaurantPublishedLegalDocumentsQuery_Query = {
  __typename?: 'Query',
  restaurant: RestaurantPublishedLegalDocumentsQuery_restaurant_Restaurant
};


export type RestaurantPublishedLegalDocumentsQueryVariables = Types.Exact<{
  restaurantId: Types.Scalars['Int']['input'];
}>;


export type RestaurantPublishedLegalDocumentsQuery = RestaurantPublishedLegalDocumentsQuery_Query;


export const RestaurantPublishedLegalDocumentsDocument = /*#__PURE__*/ document as unknown as DocumentNode<RestaurantPublishedLegalDocumentsQuery, RestaurantPublishedLegalDocumentsQueryVariables>;


/**
 * __useRestaurantPublishedLegalDocumentsQuery__
 *
 * To run a query within a React component, call `useRestaurantPublishedLegalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantPublishedLegalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantPublishedLegalDocumentsQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useRestaurantPublishedLegalDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RestaurantPublishedLegalDocumentsQuery, RestaurantPublishedLegalDocumentsQueryVariables> & ({ variables: RestaurantPublishedLegalDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestaurantPublishedLegalDocumentsQuery, RestaurantPublishedLegalDocumentsQueryVariables>(RestaurantPublishedLegalDocumentsDocument, options);
      }
export function useRestaurantPublishedLegalDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestaurantPublishedLegalDocumentsQuery, RestaurantPublishedLegalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestaurantPublishedLegalDocumentsQuery, RestaurantPublishedLegalDocumentsQueryVariables>(RestaurantPublishedLegalDocumentsDocument, options);
        }
// @ts-ignore
export function useRestaurantPublishedLegalDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RestaurantPublishedLegalDocumentsQuery, RestaurantPublishedLegalDocumentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RestaurantPublishedLegalDocumentsQuery, RestaurantPublishedLegalDocumentsQueryVariables>;
export function useRestaurantPublishedLegalDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RestaurantPublishedLegalDocumentsQuery, RestaurantPublishedLegalDocumentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RestaurantPublishedLegalDocumentsQuery | undefined, RestaurantPublishedLegalDocumentsQueryVariables>;
export function useRestaurantPublishedLegalDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RestaurantPublishedLegalDocumentsQuery, RestaurantPublishedLegalDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RestaurantPublishedLegalDocumentsQuery, RestaurantPublishedLegalDocumentsQueryVariables>(RestaurantPublishedLegalDocumentsDocument, options);
        }
export type RestaurantPublishedLegalDocumentsQueryHookResult = ReturnType<typeof useRestaurantPublishedLegalDocumentsQuery>;
export type RestaurantPublishedLegalDocumentsLazyQueryHookResult = ReturnType<typeof useRestaurantPublishedLegalDocumentsLazyQuery>;
export type RestaurantPublishedLegalDocumentsSuspenseQueryHookResult = ReturnType<typeof useRestaurantPublishedLegalDocumentsSuspenseQuery>;
export type RestaurantPublishedLegalDocumentsQueryResult = ApolloReactCommon.QueryResult<RestaurantPublishedLegalDocumentsQuery, RestaurantPublishedLegalDocumentsQueryVariables>;